import './avatar.scss';

type AvatarProps = {
  text?: JSX.Element | string;
  avatar?: string | null | undefined;
};
export function Avatar({ text, avatar }: AvatarProps) {
  return (
    <div className="avatar">
      {avatar && (
        <div className="avatar__image">
          <img src={avatar} alt="Avatar" />
        </div>
      )}
      {text && <div className="avatar__content">{text}</div>}
    </div>
  );
}
